import React, { createContext, useContext, useEffect, useState } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("puri_lang") || "de";
    } catch { return "de"; }
  });

  useEffect(() => {
    try { localStorage.setItem("puri_lang", lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.de;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
